(function(window, document, $, __tnt) {

    var me = __tnt.eedition || (__tnt.eedition = {});

    /* Public */
    me.cutouts = {

        init: function() {

            var eeData = $('*[data-eedition]').data('eedition'),
                pageUuid = $('*[data-eedition]').data('eedition-uuid'); 

            $('.segment-cutout').each(function() {
                var oData = $(this).data('segmenting'),
                    modalHeight = $(window).innerHeight() - 200,
                    newScroller = 'cutouts-' + oData.uuid,
                    newSegment = '.segment-' + oData.uuid,
                    scale =  getScale(oData.coords.width),
                    cutoutOptions = {
                        doubleTap: true,
                        freeScroll: true,
                        mouseWheel: true,
                        scrollX: true,
                        scrollY: true,
                        zoom: true
                    };

                if ($(this).parents('#segment-modals').length) {
                    $(newSegment)
                        .attr('width', oData.coords.width * scale)
                        .attr('height', oData.coords.height * scale)
                        .scaleCanvas({ scale: 1 * scale });
                } else {
                    $(newSegment)
                        .attr('width', oData.coords.width)
                        .attr('height', oData.coords.height)
                        .drawImage({
                            source: eeData[pageUuid].magnified,
                            x: 0, y: 0,
                            sWidth: oData.coords.width,
                            sHeight: oData.coords.height,
                            sx: oData.coords.left,
                            sy: oData.coords.top,
                            fromCenter: false
                        });
                }

                function getScale() {
                    var panelWidth = $(window).width() - 40;
                    if (panelWidth > oData.coords.width) {
                        return 1;
                    } else {
                        return ($(window).width() - 40)/oData.coords.width;
                    }
                }

                // Cutout modal height
                $('.segment-cutout-area').css('height', modalHeight);

                // Init cutout scroller
                if (!me.iscroll[newScroller]) {
                    me.iscroll[newScroller] = new IScroll('#segment-cutout-container-' + oData.uuid, cutoutOptions);
                }

                // Double Click/Tap
                var tapped = false;
                me.iscroll[newScroller].on('doubleTap', function () {
                    if (!tapped) {
                        tapped = setTimeout( function () {
                            tapped = null;
                        }, 300);
                    } else {
                        clearTimeout(tapped);
                        tapped = null;

                        // iPad
                        if (me.browser.isIpad() && me.utilities.isZoom()) {
                            if (me.iscroll[newScroller].scale == 0.5) {
                                me.iscroll[newScroller].zoom(1, me.iscroll[newScroller].pointX, me.iscroll[newScroller].pointY, 500);
                            } else if (me.iscroll[newScroller].scale == 1) {
                                me.iscroll[newScroller].zoom(0.5, me.iscroll[newScroller].pointX, me.iscroll[newScroller].pointY, 500);
                            }

                        // iPhone/iPod
                        } else if ((me.browser.isIphone() || me.browser.isIpod()) && me.utilities.isZoom()) {
                            if (me.iscroll[newScroller].scale == 0.25) {
                                me.iscroll[newScroller].zoom(1, me.iscroll[newScroller].pointX, me.iscroll[newScroller].pointY, 500);
                            } else if (me.iscroll[newScroller].scale == 1) {
                                me.iscroll[newScroller].zoom(0.25, me.iscroll[newScroller].pointX, me.iscroll[newScroller].pointY, 500);
                            }

                        // Desktop
                        } else {
                            if (me.iscroll[newScroller].scale == 1) {
                                me.iscroll[newScroller].zoom(2, me.iscroll[newScroller].pointX, me.iscroll[newScroller].pointY, 500);
                            } else if (me.iscroll[newScroller].scale == 2) {
                                me.iscroll[newScroller].zoom(1, me.iscroll[newScroller].pointX, me.iscroll[newScroller].pointY, 500);
                            }
                        }
                    }
                });

                // Refresh scroller when modal is shown
                $('#modal-' + oData.uuid).on('shown.bs.modal', function() {
                    me.iscroll[newScroller].refresh();
                })

                // Refresh scroller when cutout panel is resized
                $('.cutout-panel-toggle').click(function() {

                    // Delay refresh for panel transition
                    setTimeout(function(){
                        me.iscroll[newScroller].refresh();
                    }, 400);
                })
            });
        },

        drawImage: function(segmentUuid) {
            var eeData = $('*[data-eedition]').data('eedition'),
                pageUuid = $('*[data-eedition]').data('eedition-uuid'),
                oData = $('#segment-dialog-'+segmentUuid).data('segmenting'),
                canvas = $('#segment-cutout-container-'+segmentUuid).find('#segment-'+segmentUuid);

            canvas.drawImage({
                source: eeData[pageUuid].magnified,
                x: 0, y: 0,
                sWidth: oData.coords.width,
                sHeight: oData.coords.height,
                sx: oData.coords.left,
                sy: oData.coords.top,
                fromCenter: false
            });
        }
    };

})(window, document, jQuery, __tnt);